"use strict";

import Swal from "sweetalert2";
import utils from "../blocks/_utils";

(function () {
    $('body').on('click', 'button.link-campaign-ext', function () {
        const $btn = $(this);
        
        const inputOptions = new Promise((resolve) => {

            $.request('onWPCharidyRequest', {
                flash: true,
                data: {
                    type: 'campaigns'
                },
                success: function (responseData) {
                    const variants = {};

                    responseData.data.forEach(function (el) {
                        let time = new Date(el.attributes.start_date * 1000).toISOString().substr(0,10);
                        variants[el.id] = el.attributes.title + ` (${ time })`;
                    });

                    resolve(variants)
                },
                error(xhr, text, error){
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: xhr?.responseJSON?.X_OCTOBER_ERROR_MESSAGE || text,
                    })
                }
            })
        })
        
        Swal.fire({
            title: utils.i18n('messages.confirm-action'),//'Are you sure?',
            text: 'Пожалуйста, выберите внешнюю запись для установления связи при синхронизации:',
            input: 'select',
            inputOptions: inputOptions,
            confirmButtonColor: '#3085d6',
            confirmButtonText: utils.i18n('btn.save'),
            showCloseButton: true,
        }).then((result) => {
            if (result.isConfirmed) {
                const $form = $btn.closest('form');
                $form.find('input[name="external_id"]').val(result.value)

                $form.submit();

            } else {
                console.log('close')
            }
        })
    })
})();
